/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import NotificationAPI from 'api/NotificationsAPI';

export const handleUpdateTicketNotification = async(
  ticketName: any,
  cur_user: any,
  receiver: string,
  caseId: string,
) => {
  const notification = {
    sender: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName}`,
    groupId: cur_user.selected_team.id,
    userId: receiver,
    status: 'unread',
    heading: `${ticketName} Updated`,
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} updated the ticket: ${ticketName}, `,
    link: `/monitor/ticket/${caseId}`,
    type: 'ticket',
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};

export const handleShareTicketNotification = async(
  ticketName: any,
  cur_user: any,
  receiver: string,
  caseId: string,
) => {
  const notification = {
    sender: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName}`,
    groupId: cur_user.selected_team.id,
    userId: receiver,
    status: 'unread',
    heading: `${ticketName} Shared`,
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} shared the ticket: ${ticketName}, with you `,
    link: `/monitor/ticket/${caseId}`,
    type: 'ticket',
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};

export const handleAddCommentNotification = async(
  ticketName: any,
  cur_user: any,
  receiver: string,
  caseId: string,
) => {
  const notification = {
    sender: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName}`,
    groupId: cur_user.selected_team.id,
    userId: receiver,
    status: 'unread',
    heading: `A comment added on ${ticketName}`,
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} Added a comment on: ${ticketName}, kindly review.`,
    link: `/monitor/ticket/${caseId}`,
    type: 'ticket',
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};

export const handleUploadNotification = async(
  ticketName: any,
  cur_user: any,
  receiver: string,
  caseId: string,
) => {
  const notification = {
    sender: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName}`,
    groupId: cur_user.selected_team.id,
    userId: receiver,
    status: 'unread',
    heading: `Document uploaded on ${ticketName}`,
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} uploaded a document on: ${ticketName}, kindly review.`,
    link: `/monitor/ticket/${caseId}`,
    type: 'ticket',
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};

export const handleScreenNotification = async(
  ticketName: any,
  cur_user: any,
  receiver: string,
  caseId: string,
  total: any,
) => {
  const notification = {
    sender: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName}`,
    groupId: cur_user.selected_team.id,
    userId: receiver,
    status: 'unread',
    heading: `System screening on ${ticketName}.`,
    message: `${total} new results found for: ${ticketName}, kindly review.`,
    link: `/monitor/ticket/${caseId}`,
    type: 'ticket',
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};

export const handleSettingsNotification = async(
  ticketName: any,
  cur_user: any,
  receiver: string,
  caseId: string,
  type: string,
) => {
  const notification = {
    sender: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName}`,
    groupId: cur_user.selected_team.id,
    userId: receiver,
    status: 'unread',
    heading: `Settings updated on ${ticketName}`,
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} updated  ${type} on: ${ticketName}, kindly review.`,
    link: `/monitor/ticket/${caseId}`,
    type: 'ticket',
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};

export const userDeleteTicketNotification = async(
  ticketName: any,
  cur_user: any,
  receiver: string,
) => {
  const notification = {
    groupId: cur_user.selected_team.id,
    userId: receiver,
    status: 'unread',
    heading: 'Ticket Deleted',
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} deleted ticket: ${ticketName}`,
    type: 'team',
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};

export const userJoinedNotification = async(
  cur_user: any,
  teamInfo: any,
  id: string,
) => {
  const notification = {
    groupId: teamInfo.id,
    userId: id,
    status: 'unread',
    heading: 'Team Member Added',
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} accepted your invite and joined ${teamInfo.name}`,
    type: 'team',
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};

export const inviteUserNotification = async(
  cur_user: any,
  teamInfo: any,
  id: string,
) => {
  const notification = {
    groupId: teamInfo.id,
    userId: id,
    status: 'unread',
    heading: 'Team Invite',
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} invited you to join the team: ${teamInfo.name}`,
    link: `/join-team/${teamInfo.id}`,
    type: 'invite',
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};

// NO LONGER USED

export const handleReviewTicketNotification = async(
  ticketInfo: any,
  cur_user: any,
  receiver: string,
  caseId: string,
) => {
  const notification = {
    sender: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName}`,
    groupId: cur_user.selected_team.id,
    userId: receiver,
    status: 'unread',
    heading: `${ticketInfo.ticketName} Review`,
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} request review of ticket: ${ticketInfo.ticketName}, `,
    link: `/monitor/ticket/${caseId}`,
    type: 'ticket',
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};

export const handleBITEDBReviewNotification = async(
  _ticketInfo: any,
  cur_user: any,
  receiver: string,
  item: any,
  type: 'supplier' | 'product',
) => {
  const notification = {
    sender: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName}`,
    groupId: cur_user.selected_team.id,
    userId: receiver,
    status: 'unread',
    heading: `${type.charAt(0).toUpperCase() + type.slice(1)} Review`,
    message: `${cur_user.basics?.firstName} ${
      cur_user.basics?.lastName
    } requested review of ${type}: ${item?.name ?? ''}`,
    link: `/supplier/${item?.id}`,
    type: 'ticket',
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};

export const handleApproveTicketNotification = async(
  ticketInfo: any,
  cur_user: any,
  receiver: string,
  caseId: string,
) => {
  const notification = {
    sender: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName}`,
    groupId: cur_user.selected_team.id,
    userId: receiver,
    status: 'unread',
    heading: `${ticketInfo.ticketName} Approval`,
    message: `${cur_user.basics?.firstName} ${cur_user.basics?.lastName} approved ticket: ${ticketInfo.ticketName}, `,
    link: `/monitor/ticket/${caseId}`,
    type: 'ticket',
  };
  await NotificationAPI.createNotification({ newNotification: notification });
};
